import { OmitType, PartialType } from 'nestjs-mapped-types';
import { field } from '../../fields';
import { OlfactiveFamilyId } from '../id';

export class OlfactiveTranslationDto {
	@field.String()
	lang!: string;

	@field.String({ nullable: true })
	name!: string | null;
}

export class OlfactiveUpdateDto {
	@field.String({ trim: true, min: 1 })
	name!: string;

	@field.String({ trim: true, optional: true })
	image?: string;

	@field.Obj(OlfactiveTranslationDto, { array: true, optional: true })
	translations?: OlfactiveTranslationDto[];

	@field.String({ optional: true })
	comment?: string;
}

export class OlfactiveCreateDto extends OlfactiveUpdateDto {
	@OlfactiveFamilyId()
	id!: OlfactiveFamilyId;
}

export class OlfactiveImportDto extends PartialType(OmitType(OlfactiveUpdateDto, ['comment'])) {
	@OlfactiveFamilyId()
	id!: OlfactiveFamilyId;

	@field.Obj(OlfactiveTranslationDto, { array: true, optional: true })
	translations?: OlfactiveTranslationDto[];
}
